import {Component, Input} from "@angular/core";
import {IExerciseForm, IExercisesCategoryForm} from "../../workout-form/WorkoutFormFactory";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-exercises-category-multiselect',
  templateUrl: './exercises-category-multiselect.component.html',
  styleUrls: ['./exercises-category-multiselect.component.scss']
})
export class ExercisesCategoryMultiselectComponent {
  @Input() _form: FormGroup<IExercisesCategoryForm>;
  @Input() _searchControl: FormControl<string>;
  @Input() isNameSearched: boolean;


  isExerciseSearched(exercise: FormGroup<IExerciseForm>): boolean {
      if(this.isNameSearched) return true;
      return exercise.controls.regularExercise.controls.name.value.toLowerCase().includes(this._searchControl.value.toLowerCase()) || exercise.controls.pairedExercise.controls.name.value.toLowerCase().includes(this._searchControl.value.toLowerCase())
  }
}
